"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Pagination_1 = __importDefault(require("../Pagination"));
var TablePagination_1 = __importDefault(require("../Table/TablePagination"));
var SimplePagination = function SimplePagination(props) {
    if ('arrowMode' in props) {
        var _a = props.count, count = _a === void 0 ? -1 : _a, _b = props.page, page = _b === void 0 ? 1 : _b, _c = props.onChangePage, onChangePage = _c === void 0 ? function () { return undefined; } : _c, _d = props.rowsPerPage, rowsPerPage = _d === void 0 ? 25 : _d, _e = props.onChangeRowsPerPage, onChangeRowsPerPage = _e === void 0 ? function () { return undefined; } : _e, _f = props.component, component = _f === void 0 ? 'div' : _f, rest = __rest(props, ["count", "page", "onChangePage", "rowsPerPage", "onChangeRowsPerPage", "component"]);
        return (jsx_runtime_1.jsx(TablePagination_1.default, __assign({ count: count, page: page, onChangePage: onChangePage, rowsPerPage: rowsPerPage, onChangeRowsPerPage: onChangeRowsPerPage, component: component }, rest), void 0));
    }
    else {
        return jsx_runtime_1.jsx(Pagination_1.default, __assign({}, props), void 0);
    }
};
exports.default = SimplePagination;
//# sourceMappingURL=SimplePagination.js.map